import React from 'react';

import { DemoSliderControl } from '@/components/Demo';

import FlexDemo from './FlexDemo';
import Item from './Item';
import Output from './Output';

const IDEAL_SIZE = 600;

function ShrinkWords({ applyMinWidth }) {
  const ref = React.useRef();

  const [maxWidth, setMaxWidth] = React.useState(null);

  React.useEffect(() => {
    if (!ref.current) {
      return;
    }

    const bb = ref.current.getBoundingClientRect();
    const availableWidth = bb.width - 32;

    setMaxWidth(Math.min(IDEAL_SIZE, availableWidth));
  }, []);

  return (
    <div ref={ref}>
      {typeof maxWidth === 'number' && (
        <FlexDemo
          centered
          customGrid={{
            gridTemplateColumns: '1fr',
          }}
          initialValues={{
            flexShrink: 0,
            containerWidth: maxWidth,
          }}
          controls={[
            <DemoSliderControl
              key="containerWidth"
              id="containerWidth"
              label="Container width"
              min={applyMinWidth ? 100 : 150}
              max={maxWidth}
              wrapperStyle={{ width: 284 }}
            />,
          ]}
          style={{
            '--color-alert': 'var(--color-gray-300)',
          }}
        >
          {({ containerWidth, ...state }) => (
            <Output
              state={state}
              wrapperStyle={{
                width: containerWidth + 2 * 2 + 4 * 2,
                padding: 16,
                overflow: 'unset',
              }}
            >
              <Item
                layout={false}
                style={{
                  minWidth: applyMinWidth ? '0px' : undefined,
                }}
              >
                The longest word in this item is “sesquipedalian”.
              </Item>
              <Item
                layout={false}
                style={{
                  minWidth: applyMinWidth ? '0px' : undefined,
                }}
              >
                This one has no long words.
              </Item>
            </Output>
          )}
        </FlexDemo>
      )}
    </div>
  );
}

export default ShrinkWords;
